import styled from 'threads5/styles/styled';
import { FC } from 'react';

const StyledIndicatorButton = styled('button')({
  fontSize: 0, // Prevents bottom spacing around :focus-visible outline
  padding: '5px',
});

const StyledIndicatorShape = styled('span')<{ isActive: boolean }>(
  ({ theme, isActive }) => {
    return {
      display: 'inline-block',
      height: '14px',
      width: isActive ? '28px' : '14px',
      borderRadius: '7px',
      transition: 'width .3s ease-in-out, background .3s ease-in-out',
      background: isActive
        ? theme.palette['gradient/graphic/subtle/elizabeth']
        : theme.palette['gradient/background/vibrant/elizabeth'],
    };
  },
);

export const Indicator: FC<{
  isActive: boolean;
  index: number;
  onClick: (index: number) => unknown;
}> = ({ isActive = false, index, onClick }) => {
  return (
    <StyledIndicatorButton
      onClick={() => {
        return onClick(index);
      }}
      aria-label={`Go to ${index + 1}`}
    >
      <StyledIndicatorShape isActive={isActive} />
    </StyledIndicatorButton>
  );
};
